import { memo } from 'react';
import _startsWith from 'lodash/startsWith';
import _includes from 'lodash/includes';
import PropTypes from 'prop-types';
// Local files
import pdf from 'assets/images/file/pdf.png';
import word from 'assets/images/file/word.png';
import defaultDoc from 'assets/images/file/default.png';

const DocIcon = ({ type }) => {
  if (_startsWith(type, 'application/pdf')) return <img src={pdf} alt='pdf document' />;
  if (_includes(type, 'wordprocessingml')) return <img src={word} alt='word document' />;
  return <img src={defaultDoc} alt='document' />;
};

DocIcon.propTypes = {
  type: PropTypes.string.isRequired
};

export default memo(DocIcon);